<template>
  <div class="header_bj">
    <div class="header clearfix">
      <div class="nav-left fl clearfix">
        <div class="menu-con fl">
          <div class="menu-ico">
            <i></i>
            <!-- 菜单栏目开始 -->
            <div class="leve01">
              <ul>
                <li class="leve01-li">
                  <router-link :to="{ name: 'home' }" class="leve01-li-a">首页</router-link>
                </li>

                <!-- 接口开始 -->
                <li class="leve01-li" v-for="item in submenu1" :key="item.uid">
                  <router-link :to="{ name: 'list', query: { uid: item.uid } }"
                    class="leve01-li-a curr_h">{{ item.text }}</router-link>
                  <!-- 二级开始 -->
                  <div class="leve02">
                    <ul>
                      <li class="leve02-li" v-for="item2 in item.children" :key="item2.uid">
                        <router-link :to="{ name: 'list', query: { uid: item2.uid } }"
                          class="leve02-li-a">{{ item2.text }}</router-link>
                        <!-- 三级开始 -->
                        <div class="leve03">
                          <ul id="leve_square">
                            <li class="leve03-li" v-for="item3 in item2.children" :key="item3.uid">
                              <router-link :to="{ name: 'list', query: { uid: item3.uid } }"
                                class="leve03-li-a">{{ item3.text }}</router-link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <!-- <li class="leve03-li" v-for="item3 in item2.children" :key="item3.uid">
                        <router-link
                          :to="{name: 'list',query:{uid:item3.uid}}"
                          class="leve03-li-a"
                        >{{item3.text}}</router-link>
                      </li>-->
                    </ul>
                  </div>
                  <!-- 二级结束 -->
                </li>
                <!-- 接口结束 -->

                <li class="leve01-li">
                  <a href="javascript:;" class="leve01-li-a curr_h">指数</a>
                  <div class="leve02">
                    <ul>
                      <li class="leve02-li">
                        <router-link class="leve02-li-a" :to="{ name: 'obor' }">“一带一路”航贸指数</router-link>
                      </li>
                      <li class="leve02-li">
                        <router-link class="leve02-li-a"
                          :to="{ path: '/exp/msr/global', query: { id: '1' } }">海上丝路贸易指数</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="leve01-li">
                  <router-link class="leve01-li-a curr_h"
                    :to="{ name: 'list', query: { uid: defaultSubmenu[0].uid } }">{{ defaultSubmenu[0].text }}</router-link>
                  <div class="leve02">
                    <ul>
                      <li class="leve02-li" v-for="item in defaultSubmenu[0].children" :key="item.uid">
                        <router-link class="leve02-li-a"
                          :to="{ name: 'list', query: { uid: item.uid } }">{{ item.text }}</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- 数据                             -->
                <li class="leve01-li">
                  <a href="javascript:;" class="leve01-li-a curr_h">{{ defaultSubmenu[1].text }}</a>
                  <!-- 二级开始 -->
                  <div class="leve02">
                    <ul>
                      <li class="leve02-li" v-for="(item, index) in defaultSubmenu[1].children" :key="item.uid">
                        <router-link
                          :to="index < 4 ? { name: item.url } : (index === 4 ? { name: item.url, query: { uid: -83 } } : {})"
                          class="leve02-li-a">{{ item.text }}</router-link>
                        <!-- 三级开始 -->
                        <div class="leve03">
                          <ul id="leve_square">
                            <li class="leve03-li" v-for="item2 in item.children" :key="item2.uid">
                              <router-link class="leve03-li-a"
                                :to="{ name: item2.url, query: { uid: item2.uid } }"> {{ item2.text }}</router-link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- 二级结束 -->
                </li>

                <!-- 接口开始 -->
                <li class="leve01-li" v-for="item in submenu2" :key="item.uid">
                  <router-link :to="{ name: 'list', query: { uid: item.uid } }"
                    class="leve01-li-a curr_h">{{ item.text }}</router-link>
                  <!-- 二级开始 -->
                  <div class="leve02">
                    <ul>
                      <li class="leve02-li" v-for="item2 in item.children" :key="item2.uid">
                        <router-link :to="{ name: 'list', query: { uid: item2.uid } }"
                          class="leve02-li-a">{{ item2.text }}</router-link>
                        <!-- 三级开始 -->
                        <div class="leve03">
                          <ul id="leve_square">
                            <li class="leve03-li" v-for="item3 in item2.children" :key="item3.uid">
                              <router-link :to="{ name: 'list', query: { uid: item3.uid } }"
                                class="leve03-li-a">{{ item3.text }}</router-link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- 二级结束 -->
                </li>
                <!-- 接口结束 -->

                <li class="leve01-li">
                  <router-link :to="{ name: 'list2', query: { uid: '8013', subuid: '8004', attr: '阿富汗' } }" class="leve01-li-a"
                    style="color:#ffc90f;">国别</router-link>
                </li>
                <li class="leve01-li">
                  <router-link :to="{ name: 'list2', query: { uid: '8014', subuid: '8004', attr: '安徽' } }" class="leve01-li-a"
                    style="color:#ffc90f;">省市</router-link>
                </li>
              </ul>
            </div>
            <!-- 菜单栏目结束 -->
          </div>
        </div>
        <router-link class="park-logo fl" :to="{ name: 'home' }">
          <!-- <img src="https://ydylxh.drcnet.com.cn/img/logo.eff9cd37.png" alt=""> -->
          <img src="@/assets/imgs/logo.png" />
        </router-link>
      </div>
      <div class="nav-right fr">
        <div class="nav-lists2 fr">
          <a href="javascript:;" class="list">
            <span class="nav-item" @click="dialogVisible = true">旧版入口</span>
          </a>
          <a target="_blank" href="http://company.drcnet.com.cn/about.html?class=jj" class="list">
            <span class="nav-item">关于我们</span>
          </a>
          <router-link :to="{ name: 'introduce' }" target="_blank" class="list">
            <span class="nav-item">产品介绍</span>
          </router-link>
          <!-- <a
            target="_blank"
            href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserMain.aspx"
            class="list"
          > -->
          <a target="_blank" href="http://www.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx" class="list">
            <span class="nav-item">会员专区</span>
          </a>
          <!-- 登录 -->
          <a :href="loginUrl" class="list" v-show="isShowLogin" @click="loginIn">
            <span class="nav-item red">登录</span>
          </a>

          <!-- 已经登录 -->
          <div class="fr" v-show="isShowName">
            <a href="javascript:;" class="list" style="width:100px;padding-left: 10px;box-sizing: content-box;">
              <span class="nav-item red" style="width:100px;" :title="ShowAllname">{{ '欢迎您,' + ShowName }}</span>
            </a>
            <a href="javascript:;" class="list" style="width:45px;" @click="loginOut">
              <span class="nav-item">退出</span>
            </a>
          </div>
        </div>
        <!-- 搜索开始 -->
        <div class="nav-lists fr">
          <div class="search">
            <div class="sslist">
              <el-select :popper-append-to-body="false" popper-class="topselect" v-model="value" @change="selectKeys"
                placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label"
                  :value="item.label"></el-option>
              </el-select>
            </div>
            <el-input v-model="input" placeholder="请输入关键词" style="width:70%;height:100%;"></el-input>
          </div>
          <div class="searchbtna" @click="searchKeys">检索</div>
          <a class="searchbtnb" href="http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=5713" target="blank">检索中心</a>
          <a @click="searchGoAi()" target="blank" class="searchbtnb aibtnb">AI检索</a>
          <!-- <div class="searchbtnb guides" style="position: relative;">
            <img
              src="@/assets/imgs/guide.gif"
              style="position: absolute;right: 50%;top: -7px;transform: translate(100%);"
            />
            <router-link :to="{path:'/guide'}" class="guide">新手指南</router-link>
          </div> -->
        </div>
        <!-- 搜索结束 -->
      </div>

      <el-dialog :visible.sync="dialogVisible" width="30%">
        <span>是否永久访问旧版?</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" round plain @click="Yes">是</el-button>
          <el-button round plain @click="No">否</el-button>
          <el-button type="warning" round plain @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/require/api";
import {
  getName,
  setName,
  removeName,
  getToken,
  setToken,
  removeToken
} from "@/require/auth";
import $ from "jquery";
export default {
  name: "topchannel",
  data() {
    return {
      ischannelright: false,
      submenu1: [],
      submenu2: [],
      options: [
        {
          value: "0",
          label: "全文"
        },
        {
          value: "1",
          label: "标题"
        },
        // {
        //   value: "2",
        //   label: "作者"
        // },
        {
          value: "3",
          label: "关键词"
        },
        // {
        //   value: "4",
        //   label: "来源"
        // }
      ],
      value: "全文",
      input: "",
      defaultSubmenu: [
        {
          uid: "8016",
          text: "科技人文",
          children: [
            {
              uid: "801601",
              text: "科技",
              children: []
            },
            {
              uid: "801602",
              text: "文教卫",
              children: []
            },
            {
              uid: "801603",
              text: "旅游",
              children: []
            },
            {
              uid: "801604",
              text: "城市",
              children: []
            },
            {
              uid: "801605",
              text: "智库",
              children: []
            }
          ]
        },
        {
          uid: "7020",
          text: "数据",
          children: [
            {
              uid: "7021",
              text: "中国全球投资跟踪数据库",
              url: "cgit",
              children: []
            },
            {
              uid: "7022",
              text: "中国对外贸易数据库",
              url: "trade",
              children: []
            },
            {
              uid: "7023",
              text: "政治数据库",
              url: "GIS",
              children: []
            },
            {
              uid: "7024",
              text: "世行营商环境成熟度数据库",
              // text: "世行营商环境成熟度（B-READY）数据库",
              // text: "营商环境数据库",
              // url: "DbusinessF",
              url: "Pillar",
              children: []
            },
            {
              uid: "-83",
              text: "经济社会",
              url: "databasetable",
              children: []
            }
            // {
            //   uid: "7026",
            //   text: "能源矿产",
            //   children: [
            //     {
            //       uid: "-8001",
            //       text: "探明储量",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8002",
            //       text: "产量",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8003",
            //       text: "消费量",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8004",
            //       text: "贸易量",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8005",
            //       text: "价格",
            //       url: "databasetable",
            //       children: []
            //     },

            //     {
            //       uid: "-8006",
            //       text: "矿产就业人口",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8007",
            //       text: "全球矿业产值",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8008",
            //       text: "全球矿业景气指数",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8009",
            //       text: "全球矿业生产指数",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8010",
            //       text: "全球矿业并购指数",
            //       url: "databasetable",
            //       children: []
            //     },
            //     {
            //       uid: "-8011",
            //       text: "全球矿业公司活跃程度",
            //       url: "databasetable",
            //       children: []
            //     }
            //   ]
            // }
          ]
        }
      ],
      isShowLogin: true,
      isShowName: false,
      ShowName: "",
      loginUrl: "",
      ShowAllname: "",
      dialogVisible: false
    };
  },
  created() {
    this.loadsubmenu();
  },
  mounted() {
    if (getToken() !== null && getName() !== null) {
      this.isShowLogin = false;
      this.isShowName = true;
      this.ShowName = getName();
      this.ShowAllname = "欢迎您," + this.ShowName;
    } else {
      this.isShowLogin = true;
      this.isShowName = false;
    }
    // window.showData = res => {
    //   // res => {
    //   console.log("xiao");
    //   console.log(res, "data");
    //   // console.log(2)
    //   // console.log('结果')
    //   // console.log(res, "登录");
    //   if (res.Logined === 1) {
    //     setName(res.UserName);
    //     setToken(res.UserToken);
    //     this.isShowLogin = false;
    //     this.isShowName = true;
    //     this.ShowName = getName();
    //     this.ShowAllname = "欢迎您," + this.ShowName;
    //   }
    // };
  },
  methods: {
    searchGoAi() {
      window.open('https://search.drcnet.com.cn/aiSearch'); // 弹出一个新页面
    },
    // 下拉二级
    async loadsubmenu() {
      const { code, data } = await api.get(
        "HomePageController/getWebChannelList"
      );
      if (code === 0) {
        this.submenu1 = data.slice(0, 6);
        this.submenu1.forEach(ele => {
          if (ele.uid === "8004") {
            ele.children.forEach(item => {
              if (item.uid === "800408") {
                item.children = [];
              }
            });
          }
        });
        this.submenu2 = data.slice(6);
      }
    },
    Yes() {
      localStorage.setItem("isOldVersion", true);
      window.location.href = "http://ydyl2.drcnet.com.cn/www/ydyl/";
    },
    No() {
      localStorage.removeItem("isOldVersion");
      window.location.href = "http://ydyl2.drcnet.com.cn/www/ydyl/";
    },
    loginIn() {
      let url = "http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx";
      this.loginUrl =
        url +
        "?gourl=" +
        window.location.href.replace("?", "~~").replace("&", "^");
      this.logenter();
    },
    logenter() {
      // let loginUrl = "http://pay.drcnet.com.cn/eDRCnet.common.web/login.ashx";
      let loginUrl =
        "http://user.drcnet.com.cn/userapi/loginController/initLogin";
      this.$jsonp(loginUrl, { flag: "init" })
        .then(res => {
          if (res.Logined === 1) {
            setName(res.UserName);
            setToken(res.UserToken);
            this.isShowLogin = false;
            this.isShowName = true;
            this.ShowName = getName();
            this.ShowAllname = "欢迎您," + this.ShowName;
          }
        })
        .catch(err => {
          // console.log(err)
        });
    },
    // logenter() {
    //   let loginUrl = "http://d.drcnet.com.cn/eDRCnet.common.web/login.ashx";
    //   this.$jsonp(loginUrl, { flag: "initp", callbackName: "showData" })
    //     .then(json => {
    //       // 返回的jsonp数据不会放这里，而是在 window.jsonpCallback
    //       console.log(json);
    //     })
    //     .catch(err => {
    //       // console.log(err)
    //     });
    // },
    loginOut() {
      let loginUrl = "http://d.drcnet.com.cn/eDRCnet.common.web/login.ashx";
      this.$jsonp(loginUrl, { flag: "logoutp", callbackName: "showData" })
        .then(res => {
          removeName();
          removeToken();
          this.isShowLogin = true;
          this.isShowName = false;
          // window.location.reload();
          this.$router.go(0);
          // 判断本页面是否为首页
          resolve();
        })
        .catch(err => { });
    },
    selectKeys(val) {
      this.value = val;
    },
    searchKeys() {
      if (this.input.length === 0) {
        this.$message({
          message: "请输入查询信息",
          type: "warning"
        });
        return;
      }
      let newscope;
      this.options.forEach(item => {
        if (this.value === item.label) {
          newscope = item.value;
        }
      });
      window.open(
        "http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=5713&fields=" +
        newscope +
        "^1^1^" +
        escape(this.input)
      ); //弹出一个新页面
      this.input = "";
      this.value = "全文";
    }
    // 隐藏ID
    // hide(){
    //   let _this=this;
    //   $('body').on('mouseup', function (e) {
    //     let con = $('.menu-ico'), con2 = $('.leve01');
    //     if(!con.is(e.target) && con.has(e.target).length === 0 && !con.is(e.target) && con.has(e.target).length === 0){
    //       _this.isShowsearch = false
    //       }
    //   });
    // },
  }
};
</script>
<style lang='less' scoped>

.aibtnb {
  width: 11% !important;
}
// 搜索开始
.search {
  width: 53%;
  border-right: none;
  background-color: hsla(0, 0%, 100%, 0.8);
  margin: 0px;
  padding: 0px;
  height: 35px;
  font-size: 12px;
  float: left;
  z-index: 10000;
  border: 1px solid #1364c2;
  border-radius: 5px 0 0 5px;

  .sslist {
    border-right: 1px solid #1364c2;
    font-size: 12px;
    float: left;
    height: 100%;
    width: 30%;
    z-index: 1000;

    .el-select {
      width: 100%;
      height: 100%;

      /deep/.el-input--suffix {
        width: 100%;
        height: 100%;

        /deep/.el-input__inner {
          width: 100% !important;
          height: 100% !important;
          border-radius: 5px;
          border: 0px;
          padding-right: 0px;
          padding-left: 22%;
        }
      }

      /deep/.el-input__icon {
        width: 16px;
        line-height: 32px;
      }
    }
  }

  .el-input {
    font-size: 14px !important;
  }

  /deep/.el-input__inner {
    height: 100%;
    width: 100%;
    border: 0px;
    border-radius: 2px;
    line-height: 33px;
  }

  /deep/.el-popper[x-placement^="bottom"] .popper__arrow {
    left: 50% !important;
    transform: translate(-50%);
  }

  /deep/.el-scrollbar__wrap {
    margin-right: -17px !important;
  }
}

.searchbtna {
  width: 14%;
  line-height: 35px;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
  background-color: #1365c2;
  float: left;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
}

.searchbtnb {
  width: 15%;
  text-align: center;
  line-height: 35px;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
  float: left;
  margin-left: 1px;
  cursor: pointer;
}

.guide {
  color: #e6c44e;
  line-height: 35px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
}

// 搜索结束

.header_bj {
  height: 60px;
  width: 100%;
  background: url(../assets/imgs/navtop.jpg) no-repeat;
  background-size: 100% 100%;

  .header {
    position: relative;
    height: 60px;
    width: 100%;
  }

  .nav-left {
    height: 60px;

    .menu-con {
      width: 52px;
      height: 60px;
      border-right: 1px solid #001035;
      text-align: center;
      line-height: 50px;

      .menu-ico {
        width: 60px;
        height: 60px;
        text-align: center;
        cursor: pointer;

        i {
          display: inline-block;
          margin-top: 18px;
          width: 24px;
          height: 24px;
          background: url(../assets/imgs/menu-ico.png) no-repeat 0 2px;
          transition: all 0.2s ease-in;
        }

        // 菜单
        .leve01 {
          position: absolute;
          z-index: 9999;
          top: 60px;
          left: 0px;
          display: none;
          width: 170px;
          height: 800px;
          background: rgba(32, 96, 168, 0.95);
          padding-bottom: 15px;
        }

        .leve02 {
          display: none;
          position: absolute;
          z-index: 1000;
          top: 0px;
          left: 170px;
          width: 200px;
          height: 800px;
          background: rgba(45, 112, 185, 0.95);
        }

        .leve03 {
          display: none;
          // position: absolute;
          // z-index: 1000;
          // top: 0px;
          // left: 170px;
          padding-left: 40px;
          width: 200px;
          background: rgba(24, 82, 157, 0.45);
        }

        .leve01-li-a,
        .leve02-li-a,
        .leve03-li-a {
          display: block;
          // height: 36px;
          line-height: 36px;
          color: #fff;
          text-align: left;
          font-size: 15px;
          -webkit-transition: all 0.4s;
          transition: all 0.4s;
          border-bottom: 1px dotted #427bb7;
          // padding: 0 10px;
          padding-left: 14px;
          // padding-left: 20px;
        }

        .leve03-li {
          color: #eff2f6 !important;
        }

        .leve03-li-a {
          color: #eff2f6;
          padding-left: 0px;
          border-bottom: 0px dotted transparent !important;
        }

        .leve01-li-a:hover,
        .leve02-li-a:hover {
          background: #22579b;
        }

        .leve01-li:hover .leve02 {
          display: block;
        }

        .leve01-li:hover .leve03 {
          display: block;
        }
      }
    }

    .park-logo {
      margin-top: 12px;
      margin-left: 6px;
    }
  }

  .nav-right {
    margin-right: 1vh;
    width: 66%;

    .nav-lists2 {
      color: #34c4fe;
      width: 397px;

      .list {
        padding: 0px;
        z-index: 2;
        cursor: pointer;
        color: #34c4fe;
        width: 60px;
        display: inline-block;
        overflow: hidden;
      }

      .nav-item {
        display: inline-block;
        font-size: 13px;
        color: #fff;
        cursor: pointer;
        margin-top: 21px;
        width: 100%;
        overflow: hidden;
        height: 17px;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-right: 1px solid #8493e6;
      }
    }

    .nav-lists {
      margin-top: 13px;
      color: #34c4fe;
      width: 49%;
      // .list {
      //   padding: 0 8px;
      //   .nav-item {
      //     // height: 60px;
      //     // line-height: 60px;
      //     font-size: 14px;
      //     color: #fff;
      //     opacity: 0.6;
      //     cursor: pointer;
      //     margin-top: 21px;
      //   }
      // }
    }
  }
}

//搜索
.curr_h {
  background: url(../assets/imgs/more.png) no-repeat 135px 9px;
  display: block;
}

.menu-ico:hover .leve01 {
  display: block !important;
}

#leve_square {
  list-style: disc outside;
}
</style>